import React from 'react'

import boosting from '../../assets/images/home/boosting.webp'
import SlideImage from '../../components/slide-image/SlideImage'
import RedCardBlock from '../../components/red-card-block/RedCardBlock'
import {
  HomeBenefits,
  HomeBlogPreview,
  HomeCarousel,
  HomeDeal,
  HomeDescription
} from './components'
import Paths from '../../utils/paths'
import useStyles from './Home.styles'

export default function Home () {
  const classes = useStyles({ width: window.innerWidth })

  return (
    <div>
      <HomeCarousel />
      <HomeDeal />
      <div className={classes.blueBlock}>
        <h2 className={classes.blueBlockTitle}>
          Unlike any other
          <br />
          financial tool
        </h2>
      </div>
      <HomeDescription />
      <HomeBenefits />
      <SlideImage
        title='Boosting employee financial wellness is better for your bottom line'
        text={
          <div>
            <p>
              By offering a diverse range of low-risk financial tools, we help employees take big
              steps to improve their financial lives.
            </p>
            <p>
              It's no surprise that talented{' '}
              <b>people want to join, and stay at, companies who care.</b>
            </p>
          </div>
        }
        image={boosting}
        buttonLink={Paths.BENEFITS}
      />
      <RedCardBlock title='Ready to transform your workplace?' buttonText='Get a demo' />
      <HomeBlogPreview />
    </div>
  )
}
